global.colorMap = {
  keyword: '#ffc53d',
  location: '#ff4d4f',
  organization: '#b7eb8f',
  person: '#40a9ff',
  xlink: '#FF66ff',
  extension: '#4169E1',
  open: '#FF7F50',
  extision: '#780650',
  cooccurence: '#00474f'
}